// Theme: nebula
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'nebula',
  name: 'NEBULA',
  tagline: 'NEBULA',
  description: 'Nebulosa galactica. Magenta e roxo com estrelas brilhantes.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 2200,
  swatches: ['#0D0520', '#D946EF', '#1A0B33', '#FAE8FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 14px 36px rgba(217, 70, 239, 0.10)',
      '--shadow-card-active': '0 16px 42px rgba(217, 70, 239, 0.10)'
    },
    shellClasses: 'font-sans theme-nebula'
  },
  colorVars: {
    '--accent': '#D946EF',
    '--accent-foreground': '#0D0520',
    '--background': '#0D0520',
    '--border': '#6B2B8A',
    '--card': '#1A0B33',
    '--card-border-active': 'rgba(217, 70, 239, 0.10)',
    '--card-completed': '#231046',
    '--card-foreground': '#FAE8FF',
    '--card-glow': 'rgba(217, 70, 239, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D0520',
    '--foreground': '#FAE8FF',
    '--hold-fill': '#D946EF',
    '--input': '#1A0B33',
    '--modal-bg': '#0D0520',
    '--modal-border': '#6B2B8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(217, 70, 239, 0.10)',
    '--muted': '#6B2B8A',
    '--muted-foreground': '#D3A1E0',
    '--nav-active': '#D946EF',
    '--nav-bg': '#0D0520',
    '--popover': '#1A0B33',
    '--popover-foreground': '#FAE8FF',
    '--primary': '#D946EF',
    '--primary-foreground': '#0D0520',
    '--ring': '#D946EF',
    '--secondary': '#6B2B8A',
    '--secondary-foreground': '#FAE8FF',
    '--streak': '#D946EF',
    '--success': '#22c55e',
    '--success-foreground': '#0D0520',
    '--xp': '#D946EF',
    '--xp-bg': '#1A0B33'
  },
  resolvedVars: {
    '--accent': '#D946EF',
    '--accent-foreground': '#0D0520',
    '--accent-foreground-hsl': '258 73% 7%',
    '--accent-foreground-oklch': 'from #0D0520 l c h',
    '--accent-hsl': '292 84% 61%',
    '--accent-oklch': 'from #D946EF l c h',
    '--background': '#0D0520',
    '--background-hsl': '258 73% 7%',
    '--background-oklch': 'from #0D0520 l c h',
    '--border': '#6B2B8A',
    '--border-hsl': '280 52% 35%',
    '--border-oklch': 'from #6B2B8A l c h',
    '--border-w': '1px',
    '--card': '#1A0B33',
    '--card-border-active': 'rgba(217, 70, 239, 0.10)',
    '--card-completed': '#231046',
    '--card-completed-hsl': '261 63% 17%',
    '--card-completed-oklch': 'from #231046 l c h',
    '--card-foreground': '#FAE8FF',
    '--card-foreground-hsl': '287 100% 95%',
    '--card-foreground-oklch': 'from #FAE8FF l c h',
    '--card-glow': 'rgba(217, 70, 239, 0.10)',
    '--card-hsl': '263 65% 12%',
    '--card-oklch': 'from #1A0B33 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D0520',
    '--destructive-foreground-hsl': '258 73% 7%',
    '--destructive-foreground-oklch': 'from #0D0520 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FAE8FF',
    '--foreground-hsl': '287 100% 95%',
    '--foreground-oklch': 'from #FAE8FF l c h',
    '--hold-fill': '#D946EF',
    '--hold-fill-hsl': '292 84% 61%',
    '--hold-fill-oklch': 'from #D946EF l c h',
    '--input': '#1A0B33',
    '--input-hsl': '263 65% 12%',
    '--input-oklch': 'from #1A0B33 l c h',
    '--modal-bg': '#0D0520',
    '--modal-bg-hsl': '258 73% 7%',
    '--modal-bg-oklch': 'from #0D0520 l c h',
    '--modal-border': '#6B2B8A',
    '--modal-border-hsl': '280 52% 35%',
    '--modal-border-oklch': 'from #6B2B8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(217, 70, 239, 0.10)',
    '--muted': '#6B2B8A',
    '--muted-foreground': '#D3A1E0',
    '--muted-foreground-hsl': '288 50% 75%',
    '--muted-foreground-oklch': 'from #D3A1E0 l c h',
    '--muted-hsl': '280 52% 35%',
    '--muted-oklch': 'from #6B2B8A l c h',
    '--nav-active': '#D946EF',
    '--nav-active-hsl': '292 84% 61%',
    '--nav-active-oklch': 'from #D946EF l c h',
    '--nav-bg': '#0D0520',
    '--nav-bg-hsl': '258 73% 7%',
    '--nav-bg-oklch': 'from #0D0520 l c h',
    '--popover': '#1A0B33',
    '--popover-foreground': '#FAE8FF',
    '--popover-foreground-hsl': '287 100% 95%',
    '--popover-foreground-oklch': 'from #FAE8FF l c h',
    '--popover-hsl': '263 65% 12%',
    '--popover-oklch': 'from #1A0B33 l c h',
    '--primary': '#D946EF',
    '--primary-foreground': '#0D0520',
    '--primary-foreground-hsl': '258 73% 7%',
    '--primary-foreground-oklch': 'from #0D0520 l c h',
    '--primary-hsl': '292 84% 61%',
    '--primary-oklch': 'from #D946EF l c h',
    '--radius': '16px',
    '--ring': '#D946EF',
    '--ring-hsl': '292 84% 61%',
    '--ring-oklch': 'from #D946EF l c h',
    '--secondary': '#6B2B8A',
    '--secondary-foreground': '#FAE8FF',
    '--secondary-foreground-hsl': '287 100% 95%',
    '--secondary-foreground-oklch': 'from #FAE8FF l c h',
    '--secondary-hsl': '280 52% 35%',
    '--secondary-oklch': 'from #6B2B8A l c h',
    '--shadow-card': '0 14px 36px rgba(217, 70, 239, 0.10)',
    '--shadow-card-active': '0 16px 42px rgba(217, 70, 239, 0.10)',
    '--streak': '#D946EF',
    '--streak-hsl': '292 84% 61%',
    '--streak-oklch': 'from #D946EF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0D0520',
    '--success-foreground-hsl': '258 73% 7%',
    '--success-foreground-oklch': 'from #0D0520 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(292 84% 61% / 0.15)',
    '--xp': '#D946EF',
    '--xp-bg': '#1A0B33',
    '--xp-bg-hsl': '263 65% 12%',
    '--xp-bg-oklch': 'from #1A0B33 l c h',
    '--xp-hsl': '292 84% 61%',
    '--xp-oklch': 'from #D946EF l c h'
  }
}
